export default __webpack_public_path__ + "static/media/132016773_217873253081413_1007351590026612244_n.e1f1a485.jpg";